const hotels = {
  accommodation: "Chỗ ở", // translated 
  hotel: "Khách sạn", // translated 
  hotels: "Khách sạn", // translated 
  back: "Mặt sau", // translated 
  rooms: "Phòng", // translated 
  viewPictures: "Xem hình ảnh", // translated 
  showMore: "hiển thị thêm", // translated 
  bookingInformation: "Thông tin đặt chỗ", // translated 
  importantInformation: "Thông tin quan trọng", // translated
  cancellationPolicy: "Chính sách hủy bỏ", // translated 
  from: "Từ", // translated 
  to: "Προς την", // translated 
  cancellationIs: "việc hủy bỏ là", // translated 
  free: "miễn phí", // translated 
  chargeableWithFeeOf: "phải trả phí", // translated 
  prebook: "Đặt trước", // translated 
  guests: "Khách", // translated 
  payment: "Sự chi trả", // translated 
  byClicking: "Bằng cách nhấp chuột", // translated 
  next: "Kế tiếp", // translated 
  youAreAgreeingToOur: "Bạn đồng ý với các điều khoản của chúng tôi.", // translated 
  termsAndConditions: "Điều khoản và điều kiện", // translated 
  previous: "Trước", // translated 
  cancel: "Hủy bỏ", // translated 
  mealPlan: "Kế hoạch bữa ăn", // translated 
  roomType: "Loại phòng", // translated 
  description: "Sự miêu tả", // translated 
  readLess: "Đọc ít hơn", // translated 
  readMore: "Đọc thêm", // translated 
  facilities: "Cơ sở", // translated 
  viewLess: "Xem ít hơn", // translated 
  viewMore: "Xem thêm", // translated 
  less: "ít hơn", // translated 
  more: "hơn", // translated 
  notAvailable_short: "Không áp dụng", // translated 
  backToHotelList: "Trở lại danh sách khách sạn", // translated 
  viewOnMap: "Xem trên bản đồ", // translated 
  sleeps: "Ngủ", // translated 
  adults: "Người lớn", // translated 
  yearsOld: "tuổi", // translated 
  type: "Kiểu", // translated 
  bedding: "Bộ đồ giường", // translated 
  selectRoom: "Chọn phòng", // translated 
  selectRooms: "Chọn phòng", // translated 
  city: "Thành phố", // translated 
  checkIn: "Đăng ký vào", // translated 
  checkOut: "Hãy xem", // translated 
  date: "Ngày", // translated 
  dates: "Ngày tháng", // translated 
  persons: "Người", // translated 
  stillOnTrialQuestionToUpgrade:
    "Ối! Có vẻ như bạn vẫn đang sử dụng gói dùng thử. Bạn cần phải là thành viên chính thức để đặt chỗ. Bạn có muốn nâng cấp ngay bây giờ không?", // translated 
  stillOnTrialQuestionToUpgradeNonElligib:
    "Ối! Có vẻ như bạn chưa đăng ký. Bạn cần trở thành thành viên đã được xác nhận để đặt chỗ. Bạn có muốn nâng cấp ngay bây giờ không?", // translated 
  completeProfile: "Vui lòng hoàn tất hồ sơ người dùng của bạn trước.", // translated 
  upgrade: "Αναβαθμίζω", // translated 
  close: "Đóng", // translated 
  viewDetails: "Xem chi tiết", // translated 
  name: "Tên", // translated 
  rating: "Xếp hạng", // translated 
  budget: "Ngân sách", // translated 
  orderBy: "Sắp xếp theo", // translated 
  priceLowestFirst: "Giá (từ thấp nhất đến cao nhất)", // translated 
  priceHighestFirst: "Giá (cao nhất trước)", // translated 
  ratingLowestFirst: "Xếp hạng (thấp nhất trước)", // translated 
  ratingHighestFirst: "Xếp hạng (cao nhất trước)", // translated 
  starRatingAndPrice: "Xếp hạng sao và giá cả", // translated 
  biggestSavingsFirst: "Ưu đãi lớn nhất trước tiên", // translated 
  select: "Lựa chọn", // translated 
  reset: "Cài lại", // translated 
  apply: "Áp dụng", // translated 
  filterBy: "Lọc theo", // translated 
  myProfile: "Hồ sơ của tôi", // translated 
  login: "Đăng nhập", // translated 
  roomOnly: "Chỉ bao phòng", // translated 
  bedAndBreakfast: "Nhà nghỉ B&B", // translated 
  halfBoard: "Bao ăn sáng và tối", // translated 
  fullBoard: "Bao ăn ở trọn gói", // translated 
  allInclusive: "Bao trọn gói", // translated 
  filter: "Lọc", // translated 
  mapView: "Chế độ xem bản đồ", // translated 
  results: "kết quả", // translated 
  listView: "Chế độ xem danh sách", // translated 
  newSearch: "Tìm kiếm mới", // translated 
  editSearch: "Chỉnh sửa tìm kiếm", // translated 
  all: "Tất cả", // translated 
  multiple: "Nhiều", // translated 
  editProfile: "Chỉnh sửa hồ sơ", // translated 
  backToHotelsList: "Trở lại danh sách khách sạn", // translated 
  roomName: "Tên phòng", // translated 
  mealType: "Loại bữa ăn", // translated 
  freeCancellation: "Hủy miễn phí", // translated 
  yes: "Đúng", // translated 
  no: "Οχι", // translated 
  filters: "Bộ lọc", // translated 
  cancellationNonRefundable: "Việc hủy đặt phòng sẽ không được hoàn tiền.", // translated 
  hotelRating: "Xếp hạng khách sạn", // translated 
  any: "Bất kì", // translated 
  off: "Tắt", // translated 
  performNewSearch: "Thực hiện tìm kiếm mới", // translated 
};


export default hotels;
